import Model, { attr } from '@ember-data/model';
import type { Type } from '@warp-drive/core-types/symbols';

export default class GrantModel extends Model {
  declare [Type]: 'grant';
  @attr declare token: string;
}
